class CartUpsellVariantSelector {
  constructor() {
    this.init();
  }

  init() {
    this.setupEventListeners();
  }

  setupEventListeners() {
    document.querySelectorAll('[data-variant-selector]').forEach(selector => {
      selector.addEventListener('change', (event) => this.handleVariantChange(event));
    });
  }

  handleVariantChange(event) {
    const select = event.target;
    const selectedOption = select.options[select.selectedIndex];
    const productCard = select.closest('[data-product-card]');
    const selectButton = productCard.querySelector('[data-select-product]');
    const priceElement = productCard.querySelector('[data-variant-price]');
    const comparePriceElement = productCard.querySelector('[data-variant-compare-price]');
    
    // Get product data
    const productData = JSON.parse(productCard.dataset.productJson);
    const selectedVariant = productData.variants.find(variant => variant.id.toString() === select.value);
    
    // Update form inputs
    const form = productCard.querySelector('form[id^="wishlist_form_"]');
    if (form) {
      form.querySelector('input[name="ProductVariantId"]').value = selectedVariant.id;
      form.querySelector('input[name="ProductPrice"]').value = selectedVariant.price;
      
      // Update image if variant has a different image
      if (selectedVariant.featured_image) {
        form.querySelector('input[name="ProductImage"]').value = selectedVariant.featured_image.src;
      }
    }

    // Update price
    if (priceElement) {
      priceElement.textContent = selectedOption.dataset.variantPrice;
    }

    // Update compare price
    if (comparePriceElement) {
      comparePriceElement.textContent = selectedOption.dataset.variantComparePrice;
    }

    // Update select button
    if (selectButton) {
      selectButton.dataset.selectProduct = select.value;
      const isAvailable = selectedOption.dataset.variantAvailable === 'true';
      selectButton.disabled = !isAvailable;
      
      // If the button was previously selected (has 'active' class), update the text to "Selected"
      // otherwise keep it as "Select"
      if (selectButton.classList.contains('active')) {
        selectButton.textContent = 'Selected';
      } else {
        selectButton.textContent = isAvailable ? 'Select' : 'Sold Out';
      }

      // Update the WhyNotAlsoAdd component's selected IDs
      const whyNotAlsoAdd = document.querySelector('why-not-also-add');
      if (whyNotAlsoAdd && selectButton.classList.contains('active')) {
        // Remove old variant ID and add new one
        whyNotAlsoAdd.ids = whyNotAlsoAdd.ids.filter(id => id !== Number(selectButton.dataset.selectProduct));
        whyNotAlsoAdd.ids.push(Number(select.value));
      }
    }

    // Update current variant
    if (productCard) {
      productCard.dataset.currentVariant = select.value;
    }
  }
}

// Initialize the variant selector
window.addEventListener('DOMContentLoaded', () => {
  new CartUpsellVariantSelector();
}); 